import axios from "axios";

import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// CLIENT PO & COST CENTER RELATED APIs
// ==============================================

// 1. Get Client PO for Report
export const getClientPOForReport = async (params) => {
    try {
        const { CCCode, PONO } = params;
         // DEBUG
        
        const queryParams = new URLSearchParams({
            CCCode: CCCode || '',
            PONO: PONO || ''
        });
        
        const response = await axios.get(
            `${API_BASE_URL}/Reports/GetClientPOForReport?${queryParams}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 2. Get Client PO by Cost Center
export const getClientPObyCC = async (CCCode) => {
    try {
         // DEBUG
        
        const queryParams = new URLSearchParams({
            CCCode: CCCode || ''
        });
        
        const response = await axios.get(
            `${API_BASE_URL}/Accounts/GetClientPObyCC?${queryParams}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 3. Get All Cost Centers Client
export const getAllCostCentersClient = async () => {
    try {
         // DEBUG
        
        const response = await axios.get(
            `${API_BASE_URL}/Accounts/GetAllCostCentersclient`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};